import UAParser from 'ua-parser-js'
import {getDeviceInfo} from './getDeviceInfo'
import {v4 as uuidv4} from 'uuid'
import {isWeb} from './isWeb'
import { generateDeviceUUID } from './generateDeviceUUID'

const isLGWebOS = (): boolean => {
    return !!(window as any)?.['PalmSystem']
}

const isSamsungTizen = (): boolean => {
    return !!(window as any)?.['tizen'] || !!localStorage.getItem('TIZEN_DUID')
}

// @todo
// Not sure if this list of userAgent is specific for laptop browser...
const isLaptopBrowser = () => {
    return (
        navigator &&
        navigator.userAgent &&
        ['OPR', 'Edge', 'MSIE', 'Opera', 'Safari', 'Chrome', 'Trident', 'Firefox'].some(n =>
            navigator.userAgent.includes(n)
        )
    )
}

const isHisensePlateform = () => {
    return navigator.userAgent.includes('Hisense') || navigator.userAgent.includes('VIDAA')
}

/**
 *
 * @param {'webos' | 'laptop' | 'tizen' | 'hisense'} platformName
 * @returns {boolean}
 */

export const isPlatform = (platformName: any): boolean => {
    switch (platformName) {
        case 'laptop':
            return isWeb
        case 'webos':
            return isLGWebOS()
        case 'tizen':
            return isSamsungTizen()
        case 'hisense':
            return isHisensePlateform()
        default:
            return false
    }
}

export const getChromiumVersion = (): number => {
    const info = UAParser(window.navigator.userAgent)
    return Number(info?.browser?.major)
}

export const isLegacyBrowser = () => {
    return getChromiumVersion() < 53 // version of webOS 4 (2018)
}

export const getBrowserName = (voltApi: any) => {
    const userAgent = navigator.userAgent

    switch (true) {
        case !isWeb:
            return voltApi.Constants.platform.smartTvOs
        case userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1:
            return voltApi.Constants.platform.chrome
        case userAgent.indexOf('Edge') > -1:
            return voltApi.Constants.platform.edge
        case userAgent.indexOf('Edg') > -1:
            return voltApi.Constants.platform.edgeChromium
        case userAgent.indexOf('Chrome') > -1:
            return voltApi.Constants.platform.chrome
        case userAgent.indexOf('Safari') > -1:
            return voltApi.Constants.platform.safari
        case userAgent.indexOf('Firefox') > -1:
            return voltApi.Constants.platform.firefox
        default:
            return 'Unknown'
    }
}

export async function getUniqueDeviceId(): Promise<string> {
    if (!localStorage) {
        console.warn('Cannot store profile ID. localStorage is not supported.')
        return ''
    }
    const DEVICE_UUID_KEY = '___DEVICE_UUID___'
    let _deviceUuid = localStorage.getItem(DEVICE_UUID_KEY)
    if (!_deviceUuid) {
        const uniqueId = isWeb ? uuidv4(): await generateDeviceUUID()
        localStorage.setItem(DEVICE_UUID_KEY, uniqueId)
        return uniqueId
    }

    return _deviceUuid
}

export const getDeviceData = () => {
    const deviceName = getDeviceInfo().client?.name ?? 'Chrome'
    const deviceVersion = getDeviceInfo().client?.version ?? 'Chrome'
    const deviceOS = getDeviceInfo().os?.name ?? 'browser'
    const osVersion =  getDeviceInfo().os?.version
    const manufacturer = getDeviceInfo()?.device?.brand

    const DEVICE_UUID_KEY = '___DEVICE_UUID___'
    const deviceId = localStorage.getItem(DEVICE_UUID_KEY)

    return {
        manufacturer: isPlatform("laptop")? deviceName : manufacturer,
        brand: navigator.appName, // TODO deprecated
        model: deviceVersion,
        screenDimensions: {
            height: window.screen.height,
            width: window.screen.width,
        },
        deviceOS: deviceOS,
        osVersion: osVersion,
        deviceName: isWeb ? deviceName : deviceOS,
        deviceNickName: isWeb ? deviceName : deviceOS,
        deviceId: deviceId,
        uniqueDeviceId: deviceId,
        uiVersion: getVersion(),
        deviceType: isPlatform('webos') ? 'LGTV': isPlatform('tizen')? 'SamsungTV' : 'PC'
    }
}
export const modelOSInfo = (): string | Promise<string> =>{
    const webOS = window?.webOS ?? window?.webos
    if(webOS && typeof webOS !== undefined && !!(window as any)?.['PalmSystem']){
        return new Promise((resolve) => {
            webOS.service.request(
                'luna://com.webos.service.tv.systemproperty',
                {
                method: 'getSystemInfo',
                parameters: {
                    keys: ['modelName', 'sdkVersion'],
                },
                onSuccess: function (inResponse: any) {
                    const arr = inResponse

                    if (arr) {
                        localStorage.setItem('deviceModel', arr.modelName)
                        localStorage.setItem('deviceOSVersion', arr.sdkVersion)
                        resolve(arr);
                    }
                },
                onFailure: function (inError: any) {
                    resolve("error"); // Fallback on failure
                },
            });
    });
    }

}

export const isSafari = () => {
    if (navigator.userAgent.indexOf('Chrome') > -1) return false
    return navigator.userAgent.indexOf('Safari') > -1
}

export const platformSpecificClass = (className: string, platformName: string = 'stv'): string => {
    if (!isPlatform('laptop')) {
        return className
    }
    return ''
}

export const isTizenOld = (): boolean => {
    const agent = navigator.userAgent
    const match = agent.match(/Tizen (\d+\.\d+)/)
    if (!isPlatform('laptop') && match?.[0].includes('Tizen') && parseFloat(match?.[1]) <= 5.5) {
        return true
    }
    return false
}

export const getVersion = () => {
    const version = localStorage.getItem('APP_VERSION')
    if (version) {
        return version
    }

    return 'unknown'
}